import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { useTextFieldVariableIntegration } from '~/components/AgreementStudioPage/TemplateVariables/hooks/useTextFieldVariableIntegration';
import { useTemplateVariables } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariablesContext';
import { VariableFieldAdornment } from '~/components/AgreementStudioPage/TemplateVariables/VariableFieldAdornment/VariableFieldAdornment';
import { VariablePreviewLine } from '~/components/AgreementStudioPage/TemplateVariables/VariablePreviewLine/VariablePreviewLine';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import { connectControllerToTextField, rhfValidateToBottomSheet, RHF_VARIABLE_PICKER_SET_VALUE_OPTIONS } from '~/utils/react-hook-form.utils';
export default function ServiceNameTextField(param) {
    let { testId, disabled = false, disableVariablePicker, serviceNameBlacklist } = param;
    const { t } = useLocaleKeys();
    const { control, watch, setValue } = useFormContext();
    const isBundle = Boolean(watch('bundle'));
    const inputRef = useRef(null);
    const watchedServiceName = watch('serviceName');
    const { showVariableErrors, unresolvedCustomVariables } = useTemplateVariables();
    const hasUnresolvedTags = showVariableErrors && unresolvedCustomVariables.some((label)=>watchedServiceName.includes("{{".concat(label, "}}")));
    const setServiceNameField = useCallback((newValue)=>setValue('serviceName', newValue, RHF_VARIABLE_PICKER_SET_VALUE_OPTIONS), [
        setValue
    ]);
    const validateName = (name)=>serviceModel.validateName(name, {
            nameBlacklist: serviceNameBlacklist,
            isBundleName: isBundle
        });
    const { enabled, inputProps, adornmentRef, adornmentStyle, fieldAdornmentProps, resolvedValues, variablePickerPopover } = useTextFieldVariableIntegration(inputRef, setServiceNameField, {
        disabled,
        disableVariablePicker,
        showDefaultValuePopover: false
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "serviceName",
                rules: {
                    validate: validateName
                },
                render: (renderProps)=>{
                    const connected = connectControllerToTextField(renderProps);
                    const rhfRef = connected.inputRef;
                    return /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, connected), {
                                mobile: {
                                    renderAsCard: true
                                },
                                validateInBottomSheet: rhfValidateToBottomSheet(validateName),
                                bi: {
                                    name: 'service_name'
                                },
                                error: connected.error || hasUnresolvedTags,
                                helperText: hasUnresolvedTags ? t.components.templateVariables.section.fieldHelperText() : connected.helperText,
                                inputRef: (el)=>{
                                    inputRef.current = el;
                                    if (typeof rhfRef === 'function') {
                                        rhfRef(el);
                                    }
                                },
                                inputProps: inputProps,
                                autoFocus: true,
                                disabled: disabled,
                                label: isBundle ? t.serviceBuilder.serviceName.bundleLabel() : t.billing.serviceName.label(),
                                testId: testId,
                                InputProps: enabled ? {
                                    endAdornment: /*#__PURE__*/ _jsx("span", {
                                        ref: adornmentRef,
                                        style: adornmentStyle,
                                        children: /*#__PURE__*/ _jsx(VariableFieldAdornment, _object_spread({}, fieldAdornmentProps))
                                    })
                                } : undefined
                            })),
                            enabled && /*#__PURE__*/ _jsx(VariablePreviewLine, {
                                text: watchedServiceName,
                                resolvedValues: resolvedValues
                            })
                        ]
                    });
                }
            }),
            variablePickerPopover
        ]
    });
}
